import { render, staticRenderFns } from "./CriteriaAssess.vue?vue&type=template&id=5cdea79e&scoped=true&"
import script from "./CriteriaAssess.vue?vue&type=script&lang=js&"
export * from "./CriteriaAssess.vue?vue&type=script&lang=js&"
import style0 from "./CriteriaAssess.vue?vue&type=style&index=0&id=5cdea79e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdea79e",
  null
  
)

export default component.exports